import { FormControl, FormLabel, TextField } from "@mui/material";
import React, { useEffect } from "react";
import { useFormContext } from "react-hook-form";

export default function Form2() {
  const {
    register,
    formState: { errors },
  } = useFormContext();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <form className="d-flex flex-column py-3 gap-3">
      <FormControl className="d-flex flex-column bg-white rounded-4 p-3 ">
        <FormLabel>
          How much cash do owners take a year not W2 pay? This helps calculate
          overhead when bidding. We cover in all cash flow. (Total dollar value
          with all owners or partners)
        </FormLabel>
        <TextField
          sx={{ maxWidth: 360 }}
          label="Your Answer"
          variant="standard"
          {...register("ownersPay")}
          error={!!errors.ownersPay}
          helperText={errors.ownersPay ? errors.ownersPay.message : ""}
        />
      </FormControl>
      <FormControl className="d-flex flex-column bg-white rounded-4 p-3 ">
        <FormLabel>
          How much do you pay a month in vehicle loans with all payments
          combined? Please take that number and multiply by 12 for a 1-year time
          frame. You can edit this number later if you're just guessing.
        </FormLabel>
        <TextField
          sx={{ maxWidth: 360 }}
          label="Your Answer"
          variant="standard"
          {...register("loans")}
          error={!!errors.loans}
          helperText={errors.loans ? errors.loans.message : ""}
        />
      </FormControl>
      <FormControl className="d-flex flex-column bg-white rounded-4 p-3 ">
        <FormLabel>
          How much money do you pay monthly in other loans such as line of
          credit or other business ventures that come out of the company you are
          setting up? We want to make sure all costs are covered so you can have
          the most accurate estimates and breakevens.
        </FormLabel>
        <TextField
          sx={{ maxWidth: 360 }}
          label="Your Answer"
          variant="standard"
          {...register("other")}
          error={!!errors.other}
          helperText={errors.other ? errors.other.message : ""}
        />
      </FormControl>
    </form>
  );
}
